import React, { useRef } from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { Button, Form, TextField, Typography } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { isFunction, refIsRequiredError } from "@util/utils";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";
import { MEMBER_NOTE_TYPE } from "@icoach/constants";

const GuidanceNotesDialog = React.forwardRef((props, ref) => {
	const { className, open, sourceData, onClose, refresh } = props;
	if (!open) return null;
	const { guidanceNotes, memberID } = sourceData || {};
	const { postMemberProfileNotesApi } = useMemberProfileApi();
	const guidanceNotesRef = useRef();

	const doMemberProfileNotesApi = async (memberID, params) => {
		let resp = await postMemberProfileNotesApi(memberID, params);
		if (resp) {
			const { notes } = resp;
			isFunction(refresh) && refresh(notes);
			isFunction(onClose) && onClose();
		}
	};

	const handleSubmit = () => {
		if (!refIsRequiredError(guidanceNotesRef)) {
			let params = {
				noteType: MEMBER_NOTE_TYPE.GUIDANCE,
				notes: guidanceNotesRef.current && guidanceNotesRef.current.getResult(),
			};
			doMemberProfileNotesApi(memberID, params);
		}
	};
	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>指導注意</GradientColorHeader>
			<DialogContent>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<TextField
							label="指導注意"
							ref={guidanceNotesRef}
							key={guidanceNotes}
							defaultValue={guidanceNotes}
							InputProps={{
								placeholder: "請輸入 CC 圈指導注意事項（例如：會員不喜歡身體接觸、Abs/Back 需特別注意，或其他教練應留意的運動習慣）。",
							}}
							rows="4"
							multiline
							fullWidth
						/>
					</Grid>
					<Grid item xs={12}>
						<Typography variant={"body2"} className={"mb-0"}>
							此處內容不會同步至健康申告書，請依實際情況更新喔！
						</Typography>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button type={"submit"} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default GuidanceNotesDialog;
